import * as Yup from "yup";
import { US_STATES_OPTIONS } from "../../../constants/user";
import { SELECT_OPTIONS_CANADIAN_PROVINCES } from "../../constants/user";
import { validatorStringGeneric } from "../validatorStringGeneric";

export function validatorRegion(country: string) {
  switch (country) {
    case "US":
      return validatorUSState.required("Required");
    case "CA":
      return validatorCAProvince.required("Required");
    default:
      return validatorInternationalRegion;
  }
}

const validatorUSState = Yup.string().oneOf(
  US_STATES_OPTIONS.map(state => state.value),
  "Not valid"
);

const validatorCAProvince = Yup.string().oneOf(
  SELECT_OPTIONS_CANADIAN_PROVINCES.map(province => province.value),
  "Not valid"
);

const revionRegExp = new RegExp("^[ a-zA-Z0-9\u00C0-\u017F'\\#’.,:;?&*-]+$"); // Based on validatorStringTextNumbersSymbols

const validatorInternationalRegion = validatorStringGeneric
  .matches(revionRegExp, {
    excludeEmptyString: true,
    message:
      "May contain only characters: a-z, A-Z, 0-9, #, ', ., &, -, inner spaces and accented characters"
  })
  .test("no-option-word", "Value must not contain the word 'option'", value => {
    if (!value) return true; // excludeEmptyString behavior
    return !/option/i.test(value);
  });
